export const isBrowser = () => typeof window !== "undefined";

export const isLighthouse = () =>
	isBrowser() && navigator.userAgent.includes("Chrome-Lighthouse");
